export default __webpack_public_path__ + "static/media/calendar.icon.534aef3a.svg";